module.exports = __webpack_public_path__ + "static/media/home.0e4fd3e8.png";